import { Controller } from 'react-hook-form';
import Button from 'style-guide/Button';
import FormItem from 'style-guide/FormItem';
import { Input, InputNumber } from 'style-guide/Input';
import InputMask from 'react-input-mask';
import { cardDetails } from './helper';

const PaymentForm = ({ control, errors, onToggleModal, disabled }) => (
  <div>
    <Controller
      control={control}
      name='number'
      render={({ field }) => (
        <FormItem error={errors.number}>
          <InputNumber
            placeholder={`Card Number (${cardDetails.cardDigitCount} digits)`}
            variant='number'
            label='Card Number'
            {...field}
          />
        </FormItem>
      )}
    />
    <div className='d-flex flex-row'>
      <Controller
        control={control}
        name='date'
        render={({ field: { onChange, value } }) => (
          <FormItem error={errors.date}>
            <InputMask mask='99/99' selected={value} onChange={onChange} placeholder='MM/YY'>
              {() => <Input label='Expiration Date' />}
            </InputMask>
          </FormItem>
        )}
      />
      <Controller
        control={control}
        name='cvc'
        render={({ field }) => <Input {...field} label='CVV' placeholder='CVV' error={errors.cvc} />}
      />
    </div>
    <div className='d-flex justify-content-center mt--16'>
      <Button variant='secondary' onClick={onToggleModal} className='ph--40'>
        Cancel
      </Button>
      <Button variant='primary' type='submit' className='ph--32 ml--16' disabled={disabled}>
        Purchase
      </Button>
    </div>
  </div>
);

export default PaymentForm;
